import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center pt-20 pb-16 overflow-hidden" data-id="element-120">
      {/* Background ambient glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold-500/5 rounded-full blur-[120px] pointer-events-none" data-id="element-121"></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-122">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-123">
          <div className="order-2 lg:order-1 flex flex-col items-center lg:items-start text-center lg:text-left" data-id="element-124">
            <FadeIn data-id="element-125">
              <h2 className="text-gold-400 font-serif text-xl md:text-2xl mb-4 italic" data-id="element-126">
                El Arte del Desapego Magnético
              </h2>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-127">
              <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight text-glow" data-id="element-128">
                El Efecto <br data-id="element-129" />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold-300 via-gold-500 to-gold-600" data-id="element-130">
                  Sombra
                </span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-131">
              <p className="text-lg md:text-xl text-gray-300 mb-10 max-w-xl font-light leading-relaxed" data-id="element-132">
                Deja de perseguirlo y haz que él se obsesione con recuperarte en
                menos de 72 horas.
              </p>
            </FadeIn>

            <FadeIn delay={0.6} data-id="element-133">
              <Button href="#offer" data-id="element-134">
                ¡QUIERO QUE ME PERSIGA! <ArrowRight className="w-5 h-5" data-id="element-135" />
              </Button>
            </FadeIn>
          </div>

          <div className="order-1 lg:order-2 flex justify-center lg:justify-end" data-id="element-136">
            <FadeIn direction="left" delay={0.3} data-id="element-137">
              <div className="relative" data-id="element-138">
                <div className="absolute inset-0 bg-gradient-to-t from-dark via-transparent to-transparent z-10" data-id="element-139"></div>
                <div className="absolute inset-0 bg-gradient-to-r from-dark via-transparent to-transparent z-10" data-id="element-140"></div>
                <img src="https://cdn.magicpatterns.com/uploads/ejE3F8rf7E4BXUPRrDqVsU/EL_EFECTO_SOMBRA_IMAGEN.png" alt="El Efecto Sombra Book Cover" className="w-full max-w-md lg:max-w-lg object-contain drop-shadow-[0_0_30px_rgba(201,168,76,0.15)] relative z-0" data-id="element-141" />
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}